/**
 * ============================================================
 * 远景（背景）图片配置
 * ============================================================
 * PC 和移动端共用此配置
 * 图片按顺序从左到右排列，自动拼接
 */
export default [
  { src: "./xiangan/远景/远景_01.webp" },
  { src: "./xiangan/远景/远景_02.webp" },
  { src: "./xiangan/远景/远景_03.webp" },
  { src: "./xiangan/远景/远景_04.webp" },
  { src: "./xiangan/远景/远景_05.webp" },
  { src: "./xiangan/远景/远景_06_01.webp" },
  { src: "./xiangan/远景/远景_06_02.webp" },
  { src: "./xiangan/远景/远景_06_03.jpg" },
  { src: "./xiangan/远景/远景_06_04.jpg" },
  { src: "./xiangan/远景/远景_06_05.jpg" },
];

